import FormattedMessage from 'I18n/components/FormattedMessage';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import NoteLines from '../common/NoteLines';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalRequestNoteV2 = () => {
  const approval = useApprovalContext();
  if (!approval.data) {
    return null;
  }
  const {
    requestNote
  } = approval.data;
  if (!requestNote) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalRequestNote.emptyNote"
    });
  }
  return /*#__PURE__*/_jsx(NoteLines, {
    note: requestNote
  });
};